/** @mui/material imports */
import Alert from '@mui/material/Alert/Alert';
import Button from '@mui/material/Button/Button';
import Container from '@mui/material/Container/Container';
import Stack from '@mui/material/Stack/Stack';
import Toolbar from '@mui/material/Toolbar/Toolbar';
/** @mui/icons-material imports */
/** React imports */
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
/** App imports */
import { ValidatorProps } from '../../TypeScript/interfaces';
import { appContext } from '../../Contexts/AppContext';

/**
 * Validate that the user is admin, else navigate away
 * @param props standard validator props
 * @returns child component with validation applie
 */
const AdminValidator: React.FC<ValidatorProps> = (
  props: React.PropsWithChildren<ValidatorProps>,
): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { company } = useContext(appContext);
  const [isAdmin, setIsAdmin] = useState<boolean>();

  useEffect(() => {
    validateIsAdmin();
  }, [props.user]);

  const validateIsAdmin = (): void => {
    if (
      props.user.signInUserSession.idToken.payload['custom:admin'] === 'true'
    ) {
      handleIsAdmin();
    } else {
      handleNotAdmin();
    }
  };

  const handleIsAdmin = (): void => {
    setIsAdmin(true);
  };

  const handleNotAdmin = (): void => {
    setIsAdmin(false);
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      {isAdmin === true && props.children}
      {isAdmin === false && (
        <Container>
          <Toolbar />
          <h1>{t('HEADING_PAGE_ADMIN_RESTRICTED')}</h1>
          <Stack spacing={2} direction="column">
            <Alert severity="error">
              {t('PAGE_ADMIN_RESTRICTED_DESCRIPTION')}
            </Alert>
            <Stack spacing={2} direction="row">
              <Button variant="contained" color="primary" onClick={goBack}>
                {t('BUTTON_BACK')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to={`/${company}`}
              >
                {t('BUTTON_HOME')}
              </Button>
            </Stack>
          </Stack>
        </Container>
      )}
    </>
  );
};

export default AdminValidator;
